import { render, staticRenderFns } from "./handover_dialog.vue?vue&type=template&id=b8050f1e&scoped=true"
import script from "./handover_dialog.vue?vue&type=script&lang=js"
export * from "./handover_dialog.vue?vue&type=script&lang=js"
import style0 from "./handover_dialog.vue?vue&type=style&index=0&id=b8050f1e&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b8050f1e",
  null
  
)

export default component.exports